import { RepositoryGeneralScreenController } from './repository-general-screen.controller'

function repositoryGeneralScreen () {
  return {
    restrict: 'E',
    scope: {
      sections: '<',
      hasShowMoreButton: '<',
      currentPage: '<',
      getAssets: '&',
      emptyState: '<',
      modalState: '<',
      mustShowFilters: '<',
      allowedAssetExtensionsSelection: '<',
      headerToolbar: '<',
      headerNavigation: '<',
      headerTitle: '<',
      searching: '<',
      pagination: '<',
      currentFolder: '<',
      openFolder: '&',
      goBackFolder: '&',
      breadcrumbs: '<',
      singleAttach: '<'
    },
    templateUrl: '/repository/directives/repository-general-screen/repository-general-screen.html?$$REVISION$$',
    controller: RepositoryGeneralScreenController
  }
}

export { repositoryGeneralScreen }
